var map = {
	"./backward_diagonal_line.svg": 8031,
	"./blank.svg": 3793,
	"./dashed_line.svg": 1685,
	"./dot.svg": 8115,
	"./forward_diagonal_line.svg": 4054,
	"./gravel.svg": 5606,
	"./horizontal_line.svg": 1242,
	"./plus.svg": 5992,
	"./sand.svg": 4117,
	"./square.svg": 2315,
	"./vertical_line.svg": 9136,
	"./wave.svg": 8912,
	"assets/images/patterns/backward_diagonal_line.svg": 8031,
	"assets/images/patterns/blank.svg": 3793,
	"assets/images/patterns/dashed_line.svg": 1685,
	"assets/images/patterns/dot.svg": 8115,
	"assets/images/patterns/forward_diagonal_line.svg": 4054,
	"assets/images/patterns/gravel.svg": 5606,
	"assets/images/patterns/horizontal_line.svg": 1242,
	"assets/images/patterns/plus.svg": 5992,
	"assets/images/patterns/sand.svg": 4117,
	"assets/images/patterns/square.svg": 2315,
	"assets/images/patterns/vertical_line.svg": 9136,
	"assets/images/patterns/wave.svg": 8912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3630;